import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Unstable_Grid2 as Grid } from '@mui/material';
import RecentActorsIcon from '@mui/icons-material/RecentActors';

import { ValidatedTextFieldNext } from 'components';

interface Props {
  activeIcon: boolean;
  mode: 'create' | 'edit';
  working: boolean;
}

const SegmentTitle: FC<Props> = ({ activeIcon, mode, working }) => {
  const { t } = useTranslation();

  const isEditing = mode === 'edit';
  const i18nKey = isEditing ? 'common:save' : 'common:add';

  return (
    <Grid container alignItems="center" spacing={2}>
      {isEditing && (
        <Grid>
          <RecentActorsIcon color={activeIcon ? 'primary' : 'disabled'} fontSize="large" />
        </Grid>
      )}
      <Grid xs={isEditing ? true : 6}>
        <ValidatedTextFieldNext
          fullWidth
          name="title"
          placeholder={t('admin:userSegmentAdd')}
          margin="none"
          InputProps={{
            endAdornment: (
              <Box marginX={1}>
                <Button disabled={working} type="submit" variant="contained" color="primary">
                  {t(i18nKey)}
                </Button>
              </Box>
            ),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default SegmentTitle;
